import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
    IDirectoryUserBlockInn,
    IPasswordRule
} from '../models/domain';
import {AgreementType} from '../models/enums';


@Injectable({
    providedIn: 'root'
})
export class DirectoryService {

    private _httpClient: HttpClient;
    private _serverInternalError: string;

    constructor(
        private _translateService: TranslateService,
        @Inject(HttpClient) httpClient: HttpClient) {

        this._httpClient = httpClient;
        this.initTranslations();
    }

    private initTranslations() {
        this._translateService.get(
                [
                    'Common.ServerInternalError'
                ])
            .subscribe(
                result => {
                    this._serverInternalError = result['Common.ServerInternalError'];
                });
    }

    private catchErrorInternal<T>(source$: Observable<T>): Observable<T> {
        return source$
            .pipe(
                catchError((httpErrorResponse: HttpErrorResponse) => {
                    // TODO check status (400, 500, ...) and generate response
                    return of({
                        error: this._serverInternalError,
                        data: {
                        }
                    } as any as T);
            }));
    }

    public getUserBlocks(searchText): Observable<IDirectoryUserBlockInn[]> {
        return this._httpClient
            .get('./api/v1/Directory/userblock', { params: { searchText } })
            .pipe(this.catchErrorInternal.bind(this));
    }

    public getAllPasswordRules(): Observable<IPasswordRule[]> {
        return this._httpClient
            .get('./api/v1/Directory/password-rules')
            .pipe(this.catchErrorInternal.bind(this));
    }

    public GetSettingPhonePasswordAuthorization(): Observable<boolean> {
        return this._httpClient
            .get('./api/v1/Directory/settings/phone-password-authorization')
            .pipe(this.catchErrorInternal.bind(this));
    }
}
